import { combineReducers } from 'redux';

import PatientReducer from './PatientReducer';
import LayoutReducer from './LayoutReducer';
import StatusLayoutReducer from './StatusLayoutReducer';
import ConfigReducer from './ConfigReducer';
import AuthReducer from './AuthReducer';
import RegistrationReducer from './RegistrationReducer';
import AuthAlerts from './AlertsReducer';
import ManagerReducer from './ManagerReducer';
import WaveformReducer from './WaveformReducer';
import protocolReducer from './protocolReducer';

const rootReducer = combineReducers({
  protocols: protocolReducer,
  patient: PatientReducer,
  layout: LayoutReducer,
  manager: ManagerReducer,
  statusLayout: StatusLayoutReducer,
  waveform: WaveformReducer,
  config: ConfigReducer,
  authentication: AuthReducer,
  registration: RegistrationReducer,
  alert: AuthAlerts,
});

export default rootReducer;
